import { Stack, Typography } from '@mui/material'
import { Dayjs } from 'dayjs'
import { FieldArrayWithId, UseFieldArrayRemove } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { EmploymentFormValues } from '../../store/types/form/EmploymentFormValues'
import VacationPeriodEndDateInput from '../Form/EmploymentForm/inputs/VacationPeriodEndDateInput'
import VacationPeriodNumberOfDaysInput from '../Form/EmploymentForm/inputs/VacationPeriodNumberOfDaysInput'
import VacationPeriodOvertimeInput from '../Form/EmploymentForm/inputs/VacationPeriodOvertimeInput'
import VacationPeriodRemoveButton from './VacationPeriodRemoveButton'
import VacationPeriodStartDateInput from '../Form/EmploymentForm/inputs/VacationPeriodStartDateInput'

type Props = {
  vacationFields: FieldArrayWithId<EmploymentFormValues, 'vacationPeriods', 'id'>[]
  remove: UseFieldArrayRemove
  contractStart: Dayjs | null
  contractEnd: Dayjs | null
  renderVacationPeriodErrors: (index: number) => JSX.Element[] | null
}

const EmploymentFormVacationPeriodsMobileView = ({
  vacationFields,
  remove,
  contractStart,
  contractEnd,
  renderVacationPeriodErrors,
}: Props) => {
  const { t } = useTranslation()

  return (
    <Stack gap={2}>
      {vacationFields.length ? (
        vacationFields.map((field, index) => (
          <Stack
            key={field.id}
            gap={2}
            sx={{ padding: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}
          >
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="subtitle1" color="text.highEmphasis">
                {t('page.employments.table.vacationPeriod')} {index + 1}
              </Typography>
              <VacationPeriodRemoveButton index={index} onRemove={remove} />
            </Stack>
            <VacationPeriodStartDateInput index={index} contractStart={contractStart} contractEnd={contractEnd} />
            <VacationPeriodEndDateInput index={index} contractStart={contractStart} contractEnd={contractEnd} />
            <VacationPeriodNumberOfDaysInput index={index} />
            <VacationPeriodOvertimeInput index={index} />
            {renderVacationPeriodErrors(index)}
          </Stack>
        ))
      ) : (
        <Typography align="center" color="text.mediumEmphasis">
          {t('page.employments.table.noVacationPeriods')}
        </Typography>
      )}
    </Stack>
  )
}

export default EmploymentFormVacationPeriodsMobileView
